import { jsx as _jsx } from "react/jsx-runtime";
import NavigationLink from '@common/navigation/navigation-link';
import { getPluginUrl } from '../functions';
export function PluginsTableName({ id, name }) {
    return _jsx(NavigationLink, { href: getPluginUrl(id), children: name });
}
